// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1cWsY","modalFooterButton":"ModalNotes_modalFooterButton__28cEm"};